import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_COMP_ADMIN } from "src/api-setup/api-endpoints";

export const getCompAdmin = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData?.out_user_id,
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_sort_order: "ASC",
      in_sort_number: 2,
    };

    const response = await POSTAPI(false, GET_COMP_ADMIN, null, apiHeaders, requestBody, dispatch);
    if (response && response.data && response?.data?.row_result) {
      return response?.data?.row_result;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
